import {
  Avatar,
  Badge,
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography
} from '@mui/material'
import { doc, getDoc } from 'firebase/firestore'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import communityLogo from '../../../Icons/logo.png'
import polls from '../../../Icons/polls.png'
import { openDB } from 'idb'
import RTEView from '../../RichTextEditor/RTEView'

const DB_NAME = 'pdf-cache-db'
const DB_VERSION = 1
const STORE_NAME = 'pdfs'

const SearchResultTile = ({
  documentResult,
  db,
  title,
  uid,
  realDoc = null,
  inLibrary
}) => {
  const navigate = useNavigate()
  const [document, setDocument] = useState(realDoc)

  const getDate = date => {
    return new Date(date.toDate())
  }

  const showPreview = document => {
    return !document.viewCode && checkDates(document)
  }

  const checkDates = document => {
    const today = Date.now()
    return (
      (document.visibleDate &&
        today >= getDate(document.visibleDate.startDate) &&
        today <= getDate(document.visibleDate.endDate)) ||
      document.uid === uid ||
      (document.admins && document.admins.includes(uid))
    )
  }

  useEffect(() => {
    const getDocument = async dbPath => {
      var result = documentResult.path.substring(
        documentResult.path.lastIndexOf('/') + 1
      )
      const docRef = doc(db, dbPath, result)
      const docSnap = await getDoc(docRef)

      if (docSnap.exists()) {
        let data = docSnap.data()
        data.id = docSnap.id
        if (
          data.searchable ||
          (inLibrary && inLibrary.includes(data.id) && checkDates(data))
        ) {
          setDocument(data)
        }
      }
    }

    if (!realDoc && documentResult && documentResult.path) {
      getDocument(
        documentResult.path.includes('sliders') ? 'sliders' : 'documents'
      )
    }
  }, [])

  function getDateString (date) {
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
    return new Date(date.toDate()).toLocaleDateString(undefined, options)
  }

  function getComboDateString (obj) {
    const start =
      obj && obj.startDate ? new Date(getDateString(obj.startDate)) : null
    const end = obj && obj.endDate ? new Date(getDateString(obj.endDate)) : null

    const fmt = new Intl.DateTimeFormat('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    })

    const range = `${start ? fmt.format(start) : 'undefined'} – ${
      end ? fmt.format(end) : 'undefined'
    }`
    return range
  }

  const [src, setSrc] = useState(null)

  useEffect(() => {
    const fetchPdf = async () => {
      const db = await openDB(DB_NAME, DB_VERSION, {
        upgrade (db) {
          if (!db.objectStoreNames.contains(STORE_NAME)) {
            db.createObjectStore(STORE_NAME)
          }
        }
      })

      try {
        const cachedFile = await db.get(STORE_NAME, document.url)
        if (cachedFile) {
          const objectURL = URL.createObjectURL(cachedFile)
          setSrc(objectURL)
        } else {
          const response = await fetch(document.url)
          if (!response.ok) {
            throw new Error(`Failed to fetch PDF: ${response.statusText}`)
          }
          const blob = await response.blob()

          await db.put(STORE_NAME, blob, document.url)

          const objectURL = URL.createObjectURL(blob)
          setSrc(objectURL)
        }
      } catch (error) {
        console.error('Error fetching PDF: ', error)
      }
    }
    if (document && document.url) {
      fetchPdf()
    }

    return () => {
      if (src) {
        URL.revokeObjectURL(src)
      }
    }
  }, [document])

  return (
    <>
      {document && (
        <Badge
          badgeContent={document.pulseValues ? 'Pulse' : 'Document'}
          color={document.pulseValues ? 'secondary' : 'primary'}
          className='draftBadge'
        >
          <Card
            raised
            key={document.id + title}
            sx={{
              maxWidth: 250,
              minWidth: 200,
              m: 1,
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'column'
            }}
            onClick={() =>
              navigate(
                (document.pulseValues ? '/viewPulse/' : '/view/') +
                  (typeof document.customRoute !== 'undefined' &&
                  document.customRoute.length > 0
                    ? document.customRoute
                    : document.id)
              )
            }
            className='searchCard'
          >
            <CardHeader
              avatar={
                document.pulseValues ? (
                  <div style={{ textAlign: 'center' }}>
                    <Avatar
                      sx={{
                        width: 100,
                        height: 100,
                        maxHeight: 100,
                        maxWidth: 100
                      }}
                      loading='lazy'
                      variant='rounded'
                      className='previewFrame'
                      alt='Pulse Logo'
                      title={'pulse ' + document.fileName + document.uid}
                      onClick={() =>
                        navigate(
                          '/viewPulse/' +
                            (typeof document.customRoute !== 'undefined' &&
                            document.customRoute.length > 0
                              ? document.customRoute
                              : document.id)
                        )
                      }
                      src={polls}
                    />
                  </div>
                ) : showPreview(document) ? (
                  <div className='previewHolder'>
                    <div
                      className='previewCover'
                      onClick={() =>
                        navigate(
                          '/view/' +
                            (typeof document.customRoute !== 'undefined' &&
                            document.customRoute.length > 0
                              ? document.customRoute
                              : document.id)
                        )
                      }
                    ></div>
                    <iframe
                      loading='lazy'
                      className='previewFrame'
                      title={'document ' + document.fileName + document.uid}
                      src={src}
                      style={{ height: '100px', width: '234px' }}
                    />
                  </div>
                ) : (
                  <div className='previewHolder'>
                    <div
                      className='previewCover noAccessCode'
                      onClick={() =>
                        navigate(
                          '/view/' +
                            (typeof document.customRoute !== 'undefined' &&
                            document.customRoute.length > 0
                              ? document.customRoute
                              : document.id)
                        )
                      }
                    >
                      <Avatar
                        alt='logo'
                        src={
                          document.logoURL ? document.logoURL : communityLogo
                        }
                      />
                      <span style={{ fontStyle: 'italic' }}>
                        Access Code Required
                      </span>
                    </div>
                  </div>
                )
              }
              sx={{ p: 1 }}
            />
            <CardContent sx={{ p: 1 }}>
              <span style={{ fontWeight: 'bold' }}>{document.fileName}</span>
              <br />
              <span style={{ fontStyle: 'italic' }}>
                {document.displayName +
                  (document.hostName ? ` (${document.hostName})` : '')}
              </span>
              <br />
              <br />
              {document.description && document.description !== '<p></p>' && (
                <>
                  <Typography
                    component='span'
                    sx={{
                      '& .ProseMirror': {
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 4,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      },
                      whiteSpace: 'pre-line',
                      wordWrap: 'break-word'
                    }}
                  >
                    <RTEView content={document.description} />
                  </Typography>
                  <br />
                </>
              )}
              <span style={{ fontWeight: 'bold' }}>
                {document.commentDate
                  ? 'Comment Between:'
                  : 'Available for Viewing'}
              </span>

              {document.commentDate && (
                <>
                  <br />
                  <span>{getComboDateString(document.commentDate)}</span>
                </>
              )}

              <br />
              {getComboDateString(document.commentDate) !==
                getComboDateString(document.visibleDate) && (
                <>
                  <span style={{ fontWeight: 'bold' }}>Live:</span>
                  <br />
                  <span>{getComboDateString(document.visibleDate)}</span>
                </>
              )}
            </CardContent>
          </Card>
        </Badge>
      )}
    </>
  )
}

export const SearchTileRow = ({ documents, title }) => {
  return (
    <>
      <h3>{title}</h3>
      <Box
        sx={{
          display: 'flex',
          overflowX: 'auto',
          maxWidth: '90vw',
          paddingRight: 1,
          paddingTop: 2
        }}
      >
        {documents.map(document => (
          <SearchResultTile key={document.id + title} realDoc={document} />
        ))}
      </Box>
    </>
  )
}

export default SearchResultTile
